import { useState } from "react";
import { useParams } from "react-router-dom";
import Tabs, { TabItem } from "../../../../common/components/xepp/tab/Tabs";
import { AssignedStepsPage } from "./AssignedStepsPage";
import { ClaimableStepsPage } from "./ClaimableStepsPage";
import { SupervisorStepsPage } from "./SupervisorStepsPage";
import { useGetUserDepartmentsQuery } from "../../../../service/department-service";
import styles from "./steps.module.scss";

export const StepsPage = () => {
	const { departmentId } = useParams<{ departmentId: string }>();
	const [activeTab, setActiveTab] = useState("assigned");
	const [assignedCount, setAssignedCount] = useState(0);
	const [claimableCount, setClaimableCount] = useState(0);

	const { data: userDepartmentsData, isLoading } = useGetUserDepartmentsQuery();

	if (isLoading) return null;

	const currentDepartment = userDepartmentsData?.departments.find(
		dept => dept.id === departmentId
	);
	const isSupervisor = currentDepartment?.role === "Supervisor";

	if (isSupervisor && departmentId) {
		return <SupervisorStepsPage departmentId={departmentId} />;
	}

	const tabs: TabItem[] = [
		{
			key: "assigned",
			label: (
				<span className={styles.tabLabel}>
					Assigned
					{assignedCount > 0 && <span className={styles.tabBadge}>{assignedCount}</span>}
				</span>
			),
			content: <AssignedStepsPage departmentId={departmentId} onCountChange={setAssignedCount} />,
		},
		{
			key: "claimable",
			label: (
				<span className={styles.tabLabel}>
					Claimable
					{claimableCount > 0 && <span className={styles.tabBadge}>{claimableCount}</span>}
				</span>
			),
			content: <ClaimableStepsPage departmentId={departmentId} onCountChange={setClaimableCount} />,
		},
	];

	return (
		<Tabs
			tabs={tabs}
			activeTab={activeTab}
			onTabChange={key => setActiveTab(key)}
			hideBorder={true}
		/>
	);
};
